(function () {
  'use strict';

  var STORAGE_KEY = 'bs_wishlist_v1';
  var BOARDS_KEY = 'bs_wishlist_boards_v1';
  var HEART_OUTLINE =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5s-7.5-4.6-10.1-9.2C.3 8.1 1.4 4.4 4.8 3.3c2.1-.7 4.3.1 5.6 1.9l1.6 2.2 1.6-2.2c1.3-1.8 3.5-2.6 5.6-1.9 3.4 1.1 4.5 4.8 2.9 8-2.6 4.6-10.1 9.2-10.1 9.2z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>';
  var HEART_FILLED =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5s-7.5-4.6-10.1-9.2C.3 8.1 1.4 4.4 4.8 3.3c2.1-.7 4.3.1 5.6 1.9l1.6 2.2 1.6-2.2c1.3-1.8 3.5-2.6 5.6-1.9 3.4 1.1 4.5 4.8 2.9 8-2.6 4.6-10.1 9.2-10.1 9.2z"/></svg>';

  // ---------- storage ----------
  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
    updateHeaderCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
  }

  function isSaved(id) {
    id = String(id);
    return getWishlist().some(function (item) {
      return String(item.id) === id;
    });
  }

  function addItem(id, handle) {
    if (!id || !handle) return;
    var list = getWishlist();
    if (isSaved(id)) return;
    list.push({ id: String(id), handle: handle, addedAt: Date.now() });
    saveWishlist(list);
    trackKlaviyo('Added to Wishlist', handle);
  }

  function removeItem(id) {
    var list = getWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    saveWishlist(list);
  }

  function toggleItem(id, handle) {
    if (isSaved(id)) {
      removeItem(id);
      return false;
    }
    addItem(id, handle);
    return true;
  }

  // ---------- boards ----------
  function getBoards() {
    try {
      var raw = window.localStorage.getItem(BOARDS_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveBoards(list) {
    try {
      window.localStorage.setItem(BOARDS_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
    document.dispatchEvent(new CustomEvent('wishlist:boards-updated', { detail: { list: list } }));
  }

  function getBoard(boardId) {
    var found = null;
    getBoards().some(function (b) {
      if (b.id === boardId) {
        found = b;
        return true;
      }
      return false;
    });
    return found;
  }

  function createBoard(name) {
    name = (name || '').trim();
    if (!name) return null;
    var boards = getBoards();
    var board = {
      id: 'b_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7),
      name: name,
      itemIds: [],
      createdAt: Date.now()
    };
    boards.push(board);
    saveBoards(boards);
    return board;
  }

  function deleteBoard(boardId) {
    var boards = getBoards().filter(function (b) {
      return b.id !== boardId;
    });
    saveBoards(boards);
  }

  function toggleItemInBoard(boardId, itemId) {
    itemId = String(itemId);
    var boards = getBoards();
    var board = null;
    boards.some(function (b) {
      if (b.id === boardId) {
        board = b;
        return true;
      }
      return false;
    });
    if (!board) return false;
    if (!Array.isArray(board.itemIds)) board.itemIds = [];
    var idx = board.itemIds.indexOf(itemId);
    var nowIn;
    if (idx > -1) {
      board.itemIds.splice(idx, 1);
      nowIn = false;
    } else {
      board.itemIds.push(itemId);
      nowIn = true;
    }
    saveBoards(boards);
    return nowIn;
  }

  function getBoardsForItem(itemId) {
    itemId = String(itemId);
    return getBoards().filter(function (b) {
      return Array.isArray(b.itemIds) && b.itemIds.indexOf(itemId) > -1;
    });
  }

  // ---------- Klaviyo ----------
  function trackKlaviyo(eventName, handle) {
    if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
    fetchProduct(handle)
      .then(function (product) {
        if (!product) return;
        window.klaviyo.push([
          'track',
          eventName,
          {
            ProductName: product.title,
            ProductID: product.id,
            Handle: product.handle,
            URL: window.location.origin + '/products/' + product.handle,
            ImageURL: product.featured_image || (product.images && product.images[0]) || ''
          }
        ]);
      })
      .catch(function () {});
  }

  // ---------- product data ----------
  var productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    var p = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .catch(function () {
        return null;
      });
    productCache[handle] = p;
    return p;
  }

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var path = url.split('?')[0].split('#')[0];
    var parts = path.split('/products/');
    if (parts.length < 2) return null;
    return parts[1].split('/')[0];
  }

  // ---------- header count ----------
  function updateHeaderCount() {
    var count = getWishlist().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    badges.forEach(function (badge) {
      badge.textContent = count > 0 ? String(count) : '';
      badge.style.display = count > 0 ? '' : 'none';
    });
  }

  // ---------- header icon ----------
  function injectHeaderIcon() {
    var containers = document.querySelectorAll('.header__icons-right');
    containers.forEach(function (container) {
      if (container.querySelector('[data-wishlist-header-link]')) return;

      var cartEl = container.querySelector(
        "a[href*='/cart'], [data-sidebar-id='CartDrawer'], .header__cart-icon"
      );
      var anchorTarget = cartEl ? (cartEl.closest('a,button,sidebar-button') || cartEl) : null;

      var link = document.createElement('a');
      link.href = '/pages/wishlist';
      link.className = 'unstyled-link icon header__icon';
      link.setAttribute('data-wishlist-header-link', '');
      link.setAttribute('aria-label', 'Wishlist');
      link.innerHTML =
        HEART_OUTLINE +
        '<span data-wishlist-count class="wishlist-header-count" style="display:none"></span>';

      if (anchorTarget && anchorTarget.parentNode === container) {
        container.insertBefore(link, anchorTarget);
      } else {
        container.appendChild(link);
      }
    });
    updateHeaderCount();
  }

  // ---------- product card heart buttons ----------
  function makeHeartButton(id, handle) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-heart-btn';
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-product-id', id);
    btn.setAttribute('data-product-handle', handle || '');
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('aria-pressed', isSaved(id) ? 'true' : 'false');
    btn.innerHTML = isSaved(id) ? HEART_FILLED : HEART_OUTLINE;
    if (isSaved(id)) btn.classList.add('is-active');

    btn.addEventListener('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var nowSaved = toggleItem(id, handle);
      btn.classList.toggle('is-active', nowSaved);
      btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      btn.innerHTML = nowSaved ? HEART_FILLED : HEART_OUTLINE;
      btn.setAttribute('aria-label', nowSaved ? 'Remove from wishlist' : 'Add to wishlist');
      document.querySelectorAll(
        '[data-wishlist-toggle][data-product-id="' + id + '"]'
      ).forEach(function (other) {
        if (other === btn) return;
        other.classList.toggle('is-active', nowSaved);
        other.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
        other.innerHTML = nowSaved ? HEART_FILLED : HEART_OUTLINE;
      });
    });

    return btn;
  }

  function injectCardButtons(root) {
    var cards = (root || document).querySelectorAll('product-card[data-id]:not([data-wishlist-injected])');
    cards.forEach(function (card) {
      card.setAttribute('data-wishlist-injected', '');
      var id = card.getAttribute('data-id');
      var handle = handleFromUrl(card.getAttribute('data-url'));
      if (!id) return;

      var wrapper =
        card.querySelector('.product-card__images-wrapper') ||
        card.querySelector('.product-card__inner') ||
        card;
      if (!wrapper) return;

      // Only force relative positioning when the element is truly unpositioned.
      // Overwriting an existing absolute/relative position (inline OR from the
      // theme's own CSS) collapses elements that rely on position:absolute+inset
      // to fill an aspect-ratio parent (this broke product image rendering).
      if (window.getComputedStyle(wrapper).position === 'static') {
        wrapper.style.position = 'relative';
      }
      wrapper.appendChild(makeHeartButton(id, handle));
    });
  }

  // ---------- PDP button ----------
  function injectPDPButtons(root) {
    var forms = (root || document).querySelectorAll(
      'product-form[data-product-id]:not([data-wishlist-injected])'
    );
    forms.forEach(function (form) {
      if (form.closest('.product-form__sticky-buy-button')) return;
      var btnWrapper = form.querySelector('.product-form__btn-wrapper');
      if (!btnWrapper) return;
      var buyBtn = btnWrapper.querySelector('.product-form__btn');
      if (!buyBtn) return;

      form.setAttribute('data-wishlist-injected', '');

      var id = form.getAttribute('data-product-id');
      var handle = handleFromUrl(window.location.pathname);

      // Icon-only heart button, merged flush against the right edge of Add to
      // Cart (matches the reference layout: one continuous bar, cart button
      // taking most of the width, a square wishlist toggle on the end).
      //
      // IMPORTANT: the buy button is left exactly where it is — a direct
      // child of .product-form__btn-wrapper — instead of being moved into a
      // wrapping row element. When a variant is sold out, the store's
      // back-in-stock app (Yanet — the <bis-inline> custom element; not
      // Klaviyo, despite this file's earlier comments) loads asynchronously
      // and inserts its "Notify me when available" widget as a new child of
      // the button's *current* parent element. An earlier version of this
      // code moved the button into a `.wishlist-pdp-row` div for the heart
      // icon; because that move happens before the back-in-stock script
      // runs, its widget ended up inserting inside that row too — squeezed
      // in next to the heart icon instead of appearing as its own line
      // below. Leaving the button's parent untouched and merging the heart
      // in visually with absolute positioning avoids depending on DOM
      // structure the back-in-stock app (or any other app) might insert
      // into later.
      var pdpBtn = makeHeartButton(id, handle);
      pdpBtn.classList.add('wishlist-heart-btn--pdp');
      pdpBtn.innerHTML = isSaved(id) ? HEART_FILLED : HEART_OUTLINE;

      // Re-insert the heart right after the buy button whenever it's
      // missing. Idempotent (no-op once it's back in place) so it's safe to
      // call from both the initial insert and the healer observer below.
      // This exists because some sold-out/back-in-stock rendering (seen on
      // at least one real device, not reproduced in our own testing) can
      // rebuild pieces of .product-form__btn-wrapper after we've already
      // placed the heart, silently dropping it and leaving a gap where it
      // used to sit.
      function placeHeart() {
        btnWrapper.classList.add('has-wishlist-heart');
        if (!btnWrapper.contains(pdpBtn)) {
          if (btnWrapper.contains(buyBtn)) {
            buyBtn.insertAdjacentElement('afterend', pdpBtn);
          } else {
            btnWrapper.appendChild(pdpBtn);
          }
        }
      }
      placeHeart();

      // The heart needs to match the buy button's own height exactly (not
      // the wrapper's, which can be taller once a notify-me widget stacks
      // below) — sized in JS since the button's height varies by theme
      // settings, viewport and label length, and kept in sync if it changes.
      function sizeHeart() {
        if (buyBtn.isConnected) {
          pdpBtn.style.height = buyBtn.offsetHeight + 'px';
        }
      }
      sizeHeart();
      if (window.ResizeObserver) {
        new ResizeObserver(sizeHeart).observe(buyBtn);
      } else {
        window.addEventListener('resize', sizeHeart);
      }

      // Watch the wrapper for other scripts removing the heart (or
      // rebuilding children around a sold-out / back-in-stock state) and
      // put it straight back whenever that happens.
      var healer = new MutationObserver(function () {
        placeHeart();
        sizeHeart();
      });
      healer.observe(btnWrapper, { childList: true });
    });
  }

  // ---------- wishlist page ----------
  function getSharedHandles() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('shared');
    if (!raw) return null;
    return raw
      .split(',')
      .map(function (h) {
        return h.trim();
      })
      .filter(Boolean);
  }

  function applySharedViewChrome() {
    var heading = document.querySelector('.page__title');
    if (heading) heading.textContent = 'Shared Wishlist';
    var tabs = document.querySelector('.wishlist-tabs');
    if (tabs) tabs.hidden = true;
    var boardsView = document.querySelector('[data-wishlist-view="boards"]');
    if (boardsView) boardsView.hidden = true;
    var boardDetailView = document.querySelector('[data-wishlist-view="board-detail"]');
    if (boardDetailView) boardDetailView.hidden = true;
    var toolbar = document.querySelector('[data-wishlist-toolbar]');
    if (toolbar) toolbar.hidden = true;
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    var sharedHandles = getSharedHandles();
    if (sharedHandles) {
      applySharedViewChrome();
      renderSharedWishlist(sharedHandles);
      return;
    }

    var empty = document.querySelector('[data-wishlist-empty]');
    var list = getWishlist();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    grid.innerHTML = '<p class="wishlist-loading">Loading your saved items…</p>';

    Promise.all(
      list.map(function (item) {
        return fetchProduct(item.handle).then(function (product) {
          return { item: item, product: product };
        });
      })
    ).then(function (results) {
      grid.innerHTML = '';
      results.forEach(function (result) {
        if (!result.product) return;
        grid.appendChild(renderWishlistCard(result.item, result.product));
      });
      if (!grid.children.length && empty) {
        empty.style.display = '';
      }
    });
  }

  function renderSharedWishlist(handles) {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    if (!handles.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    grid.innerHTML = '<p class="wishlist-loading">Loading shared items…</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetchProduct(handle).then(function (product) {
          return product ? { item: { id: String(product.id), handle: handle }, product: product } : null;
        });
      })
    ).then(function (results) {
      grid.innerHTML = '';
      results.forEach(function (result) {
        if (!result) return;
        grid.appendChild(renderWishlistCard(result.item, result.product, null, true));
      });
      if (!grid.children.length && empty) empty.style.display = '';
    });
  }

  function addVariantToCart(variantId, btn, idleLabel) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added ✓';
        refreshCartCount();
        setTimeout(function () {
          btn.textContent = idleLabel;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        btn.textContent = idleLabel;
        btn.disabled = false;
      });
  }

  function renderWishlistCard(item, product, boardId, readOnly) {
    var card = document.createElement('div');
    card.className = 'wishlist-card';

    var variants = product.variants || [];
    // A product with real size/colour options has more than one variant.
    // Never auto-add a variant the customer didn't choose (was silently
    // adding the first/smallest size) — require an explicit size pick instead.
    var hasVariants = variants.length > 1;
    var primaryVariant = variants[0];
    var anyAvailable = variants.some(function (v) {
      return v.available;
    });
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var removeLabel = boardId ? 'Remove from board' : 'Remove';

    var variantPickerHtml = '';
    var singleActionHtml = '';
    if (hasVariants) {
      if (anyAvailable) {
        var optionsHtml = '<option value="" selected disabled>Select size</option>';
        variants.forEach(function (v) {
          var label = v.option1 || v.title || 'Option';
          optionsHtml +=
            '<option value="' +
            v.id +
            '"' +
            (v.available ? '' : ' disabled') +
            '>' +
            escapeHtml(label) +
            (v.available ? '' : ' – Sold out') +
            '</option>';
        });
        variantPickerHtml =
          '<div class="wishlist-card__variant-picker">' +
          '<select class="wishlist-card__size-select" data-wishlist-size-select>' +
          optionsHtml +
          '</select>' +
          '<div class="wishlist-card__size-error" data-wishlist-size-error hidden>Please select a size</div>' +
          '<button type="button" class="btn btn--primary wishlist-card__add-to-cart-full" data-wishlist-add-to-cart>Add to Cart</button>' +
          '</div>';
      } else {
        variantPickerHtml =
          '<div class="wishlist-card__variant-picker">' +
          '<button type="button" class="btn btn--primary wishlist-card__add-to-cart-full" disabled>Sold out</button>' +
          '</div>';
      }
    } else {
      singleActionHtml =
        '<button type="button" class="btn btn--primary wishlist-card__add-to-cart-full" data-wishlist-add-to-cart>' +
        (primaryVariant && primaryVariant.available ? 'Add to cart' : 'Sold out') +
        '</button>';
    }

    // Read-only (shared) cards get a save toggle under the buy button. Owned
    // cards get a "+ Add to board" link there instead — removal moved to the
    // small X in the corner so it doesn't compete with the cart button.
    var secondaryRowHtml = readOnly
      ? '<div class="wishlist-card__secondary-row"><button type="button" class="wishlist-card__remove" data-wishlist-save-shared>' +
        (isSaved(item.id) ? 'Saved to your wishlist' : 'Save to your wishlist') +
        '</button></div>'
      : boardId
      ? ''
      : '<div class="wishlist-card__secondary-row"><button type="button" class="wishlist-card__board-btn" data-wishlist-board-toggle>+ Add to board</button></div>';

    var removeXHtml = readOnly
      ? ''
      : '<button type="button" class="wishlist-card__remove-x" data-wishlist-remove aria-label="' +
        removeLabel +
        '"><svg viewBox="0 0 16 16" width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>';

    card.innerHTML =
      removeXHtml +
      '<a href="/products/' +
      product.handle +
      '" class="wishlist-card__image-link">' +
      (image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '') +
      '</a>' +
      '<div class="wishlist-card__info">' +
      '<a href="/products/' +
      product.handle +
      '" class="wishlist-card__title">' +
      escapeHtml(product.title) +
      '</a>' +
      (product.vendor ? '<div class="wishlist-card__vendor">' + escapeHtml(product.vendor) + '</div>' : '') +
      '<div class="wishlist-card__price">' +
      formatMoney(primaryVariant ? primaryVariant.price : product.price) +
      '</div>' +
      variantPickerHtml +
      singleActionHtml +
      secondaryRowHtml +
      '</div>' +
      (!readOnly && !boardId ? '<div class="wishlist-board-popover" data-wishlist-board-popover hidden></div>' : '');

    var addBtn = card.querySelector('[data-wishlist-add-to-cart]');
    var sizeSelect = card.querySelector('[data-wishlist-size-select]');
    var sizeError = card.querySelector('[data-wishlist-size-error]');

    if (addBtn && hasVariants && anyAvailable) {
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          if (sizeError) sizeError.hidden = true;
          sizeSelect.classList.remove('is-invalid');
        });
      }
      addBtn.addEventListener('click', function () {
        var chosenId = sizeSelect ? sizeSelect.value : '';
        if (!chosenId) {
          if (sizeError) sizeError.hidden = false;
          if (sizeSelect) sizeSelect.classList.add('is-invalid');
          return;
        }
        addVariantToCart(chosenId, addBtn, 'Add to Cart');
      });
    } else if (addBtn && !hasVariants && primaryVariant && primaryVariant.available) {
      addBtn.addEventListener('click', function () {
        addVariantToCart(primaryVariant.id, addBtn, 'Add to cart');
      });
    } else if (addBtn) {
      addBtn.disabled = true;
    }

    if (readOnly) {
      var saveBtn = card.querySelector('[data-wishlist-save-shared]');
      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          var nowSaved = toggleItem(item.id, item.handle);
          saveBtn.textContent = nowSaved ? 'Saved to your wishlist' : 'Save to your wishlist';
        });
      }
      return card;
    }

    card.querySelector('[data-wishlist-remove]').addEventListener('click', function () {
      if (boardId) {
        toggleItemInBoard(boardId, item.id);
        card.remove();
        var boardGrid = document.querySelector('[data-wishlist-board-detail-grid]');
        var boardEmpty = document.querySelector('[data-wishlist-board-detail-empty]');
        if (boardGrid && !boardGrid.children.length && boardEmpty) boardEmpty.style.display = '';
      } else {
        removeItem(item.id);
        card.remove();
        var grid = document.querySelector('[data-wishlist-grid]');
        var empty = document.querySelector('[data-wishlist-empty]');
        if (grid && !grid.children.length && empty) empty.style.display = '';
      }
    });

    if (!boardId) {
      var boardToggleBtn = card.querySelector('[data-wishlist-board-toggle]');
      var boardPopover = card.querySelector('[data-wishlist-board-popover]');
      if (boardToggleBtn && boardPopover) {
        boardToggleBtn.addEventListener('click', function (evt) {
          evt.stopPropagation();
          var isHidden = boardPopover.hidden;
          document.querySelectorAll('[data-wishlist-board-popover]').forEach(function (p) {
            p.hidden = true;
          });
          if (isHidden) {
            renderBoardPopoverContent(boardPopover, item.id);
            boardPopover.hidden = false;
          }
        });
      }
    }

    return card;
  }

  // ---------- add-to-board popover ----------
  function renderBoardPopoverContent(popover, itemId) {
    var boards = getBoards();
    var itemBoardIds = getBoardsForItem(itemId).map(function (b) {
      return b.id;
    });
    var html = '';

    if (!boards.length) {
      html += '<p class="wishlist-board-popover__empty">No boards yet.</p>';
    } else {
      html += '<ul class="wishlist-board-popover__list">';
      boards.forEach(function (board) {
        var checked = itemBoardIds.indexOf(board.id) > -1;
        html +=
          '<li><label class="wishlist-board-popover__item">' +
          '<input type="checkbox" data-wishlist-board-checkbox data-board-id="' +
          board.id +
          '"' +
          (checked ? ' checked' : '') +
          '>' +
          '<span>' +
          escapeHtml(board.name) +
          '</span>' +
          '</label></li>';
      });
      html += '</ul>';
    }

    html +=
      '<div class="wishlist-board-popover__new">' +
      '<input type="text" data-wishlist-board-name-input placeholder="New board name" maxlength="40">' +
      '<button type="button" data-wishlist-board-name-add>Add</button>' +
      '</div>';

    popover.innerHTML = html;

    popover.querySelectorAll('[data-wishlist-board-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        toggleItemInBoard(cb.getAttribute('data-board-id'), itemId);
      });
    });

    var input = popover.querySelector('[data-wishlist-board-name-input]');
    var addBtn = popover.querySelector('[data-wishlist-board-name-add]');
    if (addBtn && input) {
      addBtn.addEventListener('click', function () {
        var name = input.value.trim();
        if (!name) return;
        var board = createBoard(name);
        if (board) {
          toggleItemInBoard(board.id, itemId);
          renderBoardPopoverContent(popover, itemId);
        }
      });
      input.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          addBtn.click();
        }
      });
    }
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // ---------- wishlist page: tabs ----------
  function switchView(view) {
    document.querySelectorAll('[data-wishlist-view]').forEach(function (el) {
      el.hidden = el.getAttribute('data-wishlist-view') !== view;
    });
    document.querySelectorAll('[data-wishlist-tab]').forEach(function (tab) {
      var tabName = tab.getAttribute('data-wishlist-tab');
      var isActive = tabName === view || (view === 'board-detail' && tabName === 'boards');
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-wishlist-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var view = tab.getAttribute('data-wishlist-tab');
        switchView(view);
        if (view === 'boards') renderBoardsGrid();
      });
    });
  }

  // ---------- wishlist page: boards grid ----------
  function renderBoardsGrid() {
    var grid = document.querySelector('[data-wishlist-boards-grid]');
    var empty = document.querySelector('[data-wishlist-boards-empty]');
    if (!grid) return;
    var boards = getBoards();

    if (!boards.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    grid.innerHTML = '';
    boards.forEach(function (board) {
      grid.appendChild(renderBoardCard(board));
    });
  }

  function renderBoardCard(board) {
    var itemIds = Array.isArray(board.itemIds) ? board.itemIds : [];
    var count = itemIds.length;

    var card = document.createElement('button');
    card.type = 'button';
    card.className = 'wishlist-board-card';
    card.setAttribute('data-wishlist-board-open', board.id);
    card.innerHTML =
      '<div class="wishlist-board-card__thumbs wishlist-board-card__thumbs--' +
      Math.min(count, 4) +
      '"></div>' +
      '<div class="wishlist-board-card__info">' +
      '<span class="wishlist-board-card__name">' +
      escapeHtml(board.name) +
      '</span>' +
      '<span class="wishlist-board-card__count">' +
      count +
      (count === 1 ? ' item' : ' items') +
      '</span>' +
      '</div>';

    var thumbWrap = card.querySelector('.wishlist-board-card__thumbs');
    var wishlist = getWishlist();
    var itemsInBoard = wishlist
      .filter(function (item) {
        return itemIds.indexOf(String(item.id)) > -1;
      })
      .slice(0, 4);

    if (!itemsInBoard.length) {
      thumbWrap.classList.add('wishlist-board-card__thumbs--empty');
    } else {
      Promise.all(
        itemsInBoard.map(function (item) {
          return fetchProduct(item.handle);
        })
      ).then(function (products) {
        products.forEach(function (product) {
          if (!product) return;
          var image = product.featured_image || (product.images && product.images[0]) || '';
          if (!image) return;
          var img = document.createElement('img');
          img.src = image;
          img.alt = '';
          img.loading = 'lazy';
          thumbWrap.appendChild(img);
        });
      });
    }

    card.addEventListener('click', function () {
      openBoardDetail(board.id);
    });

    return card;
  }

  function initBoardsToolbar() {
    var createBtn = document.querySelector('[data-wishlist-create-board]');
    var form = document.querySelector('[data-wishlist-new-board-form]');
    var input = document.querySelector('[data-wishlist-new-board-input]');
    var confirmBtn = document.querySelector('[data-wishlist-new-board-confirm]');
    var cancelBtn = document.querySelector('[data-wishlist-new-board-cancel]');
    if (!createBtn || !form) return;

    function closeForm() {
      form.hidden = true;
      createBtn.hidden = false;
    }

    createBtn.addEventListener('click', function () {
      form.hidden = false;
      createBtn.hidden = true;
      if (input) {
        input.value = '';
        input.focus();
      }
    });

    if (cancelBtn) cancelBtn.addEventListener('click', closeForm);

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var name = (input && input.value.trim()) || '';
        if (!name) return;
        createBoard(name);
        closeForm();
        renderBoardsGrid();
      });
    }

    if (input) {
      input.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          if (confirmBtn) confirmBtn.click();
        } else if (evt.key === 'Escape') {
          closeForm();
        }
      });
    }
  }

  // ---------- wishlist page: board detail ----------
  function openBoardDetail(boardId) {
    var board = getBoard(boardId);
    if (!board) return;
    switchView('board-detail');

    var titleEl = document.querySelector('[data-wishlist-board-detail-title]');
    if (titleEl) titleEl.textContent = board.name;

    var deleteBtn = document.querySelector('[data-wishlist-board-delete]');
    if (deleteBtn) {
      deleteBtn.setAttribute('data-board-id', boardId);
      deleteBtn.removeAttribute('data-confirming');
      deleteBtn.textContent = 'Delete board';
    }

    renderBoardDetailGrid(boardId);
  }

  function renderBoardDetailGrid(boardId) {
    var board = getBoard(boardId);
    var grid = document.querySelector('[data-wishlist-board-detail-grid]');
    var empty = document.querySelector('[data-wishlist-board-detail-empty]');
    if (!grid || !board) return;

    var itemIds = Array.isArray(board.itemIds) ? board.itemIds : [];
    var items = getWishlist().filter(function (item) {
      return itemIds.indexOf(String(item.id)) > -1;
    });

    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    grid.innerHTML = '<p class="wishlist-loading">Loading…</p>';
    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.handle).then(function (product) {
          return { item: item, product: product };
        });
      })
    ).then(function (results) {
      grid.innerHTML = '';
      results.forEach(function (result) {
        if (!result.product) return;
        grid.appendChild(renderWishlistCard(result.item, result.product, boardId));
      });
      if (!grid.children.length && empty) empty.style.display = '';
    });
  }

  function initBoardDetailControls() {
    var backBtn = document.querySelector('[data-wishlist-board-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        switchView('boards');
        renderBoardsGrid();
      });
    }

    var deleteBtn = document.querySelector('[data-wishlist-board-delete]');
    if (deleteBtn) {
      var confirmTimeout = null;
      deleteBtn.addEventListener('click', function () {
        var boardId = deleteBtn.getAttribute('data-board-id');
        if (!boardId) return;
        if (deleteBtn.getAttribute('data-confirming') === 'true') {
          clearTimeout(confirmTimeout);
          deleteBoard(boardId);
          deleteBtn.removeAttribute('data-confirming');
          deleteBtn.textContent = 'Delete board';
          switchView('boards');
          renderBoardsGrid();
          return;
        }
        deleteBtn.setAttribute('data-confirming', 'true');
        deleteBtn.textContent = 'Click again to confirm';
        confirmTimeout = setTimeout(function () {
          deleteBtn.removeAttribute('data-confirming');
          deleteBtn.textContent = 'Delete board';
        }, 3000);
      });
    }
  }

  // ---------- wishlist page: share / clear ----------
  function initWishlistToolbar() {
    var shareBtn = document.querySelector('[data-wishlist-share]');
    var clearBtn = document.querySelector('[data-wishlist-clear]');

    if (shareBtn) {
      var shareOriginalLabel = shareBtn.textContent;
      shareBtn.addEventListener('click', function () {
        var handles = getWishlist()
          .map(function (item) {
            return item.handle;
          })
          .filter(Boolean);
        if (!handles.length) return;
        var url = window.location.origin + '/pages/wishlist?shared=' + encodeURIComponent(handles.join(','));

        if (navigator.share) {
          navigator.share({ title: 'My Wishlist', url: url }).catch(function () {});
          return;
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(url)
            .then(function () {
              shareBtn.textContent = 'Link copied';
              setTimeout(function () {
                shareBtn.textContent = shareOriginalLabel;
              }, 2000);
            })
            .catch(function () {});
        }
      });
    }

    if (clearBtn) {
      var clearOriginalLabel = clearBtn.textContent;
      var confirmTimeout = null;
      clearBtn.addEventListener('click', function () {
        if (!getWishlist().length) return;
        if (clearBtn.getAttribute('data-confirming') === 'true') {
          clearTimeout(confirmTimeout);
          saveWishlist([]);
          clearBtn.removeAttribute('data-confirming');
          clearBtn.textContent = clearOriginalLabel;
          renderWishlistPage();
          return;
        }
        clearBtn.setAttribute('data-confirming', 'true');
        clearBtn.textContent = 'Click again to confirm';
        confirmTimeout = setTimeout(function () {
          clearBtn.removeAttribute('data-confirming');
          clearBtn.textContent = clearOriginalLabel;
        }, 3000);
      });
    }
  }

  function initWishlistPageControls() {
    if (!document.querySelector('[data-wishlist-tab]')) return;
    initTabs();
    initBoardsToolbar();
    initBoardDetailControls();
    initWishlistToolbar();
  }

  // close any open add-to-board popover when clicking outside it
  function initGlobalPopoverDismiss() {
    document.addEventListener('click', function (evt) {
      if (evt.target.closest('[data-wishlist-board-popover]') || evt.target.closest('[data-wishlist-board-toggle]')) {
        return;
      }
      document.querySelectorAll('[data-wishlist-board-popover]').forEach(function (p) {
        p.hidden = true;
      });
    });
  }

  // ---------- boot ----------
  function init(root) {
    injectHeaderIcon();
    injectCardButtons(root);
    injectPDPButtons(root);
    renderWishlistPage();
    initWishlistPageControls();
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    initGlobalPopoverDismiss();

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          injectCardButtons(node.parentNode || document);
          injectPDPButtons(node.parentNode || document);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () {
      init(document);
    });
  });
})();
